import { memo } from 'react'

import { SkeletonChip } from 'shared/ui/Skeleton/SkeletonPrimitives'

import { SEARCH_QUERY_SUGGESTIONS_DISPLAY_COUNT } from '../../config'

import styles from './SearchQuerySuggestionsSkeleton.module.scss'

const SearchQuerySuggestionsSkeleton = () => (
  <ul className={styles.suggestionsList} aria-hidden='true'>
    {Array.from({ length: SEARCH_QUERY_SUGGESTIONS_DISPLAY_COUNT }).map(
      (_, i) => (
        <li className={styles.suggestionChip} key={i}>
          <SkeletonChip />
        </li>
      )
    )}
  </ul>
)

export default memo(SearchQuerySuggestionsSkeleton)
